// extracted by mini-css-extract-plugin
module.exports = {"errorPage":"ixWFVwJ4","icon":"TdJU7EYo","message":"r9KhJoMQ"};